import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Subscription } from 'rxjs'

import {
  ClientQueryParams,
  FeatureFlagNames,
  IFeatureFlag,
  LoginTypes,
  useFeatureFlags,
  useUtilsService,
} from '@procom-labs/common'

import { loginToProfileTypeMap } from '@auth-portal/types'

export const useIsMsMultiTenantClient = (): boolean => {
  const utilsService = useUtilsService()
  const { featureFlags } = useFeatureFlags()
  const [searchParams] = useSearchParams()
  const [isMSMultiTenantClient, setIsMSMultiTenantClient] =
    useState<boolean>(false)

  const loginTypeParam = searchParams.get(ClientQueryParams.loginType)

  useEffect(() => {
    let subscription = new Subscription()
    if (featureFlags?.length === 0) {
      subscription = utilsService.getVendorFeatureFlags().subscribe({
        next: (flags: IFeatureFlag[]) => {
          const MSMultiTenantFlag = flags.find(
            (flag) => flag.featureName === FeatureFlagNames.MS_SSO_Multitenant
          )
          const {
            enabled: isMSMultiTenant = false,
            eligibleProfileTypes = [],
          } = MSMultiTenantFlag || {}
          const userLoginType =
            loginTypeParam || localStorage.getItem('loginType')

          if (userLoginType) {
            const modifiedUserLoginType = (userLoginType
              .charAt(0)
              .toUpperCase() +
              userLoginType.slice(1).toLowerCase()) as LoginTypes

            const profileTypes = loginToProfileTypeMap.get(
              modifiedUserLoginType
            )
            const shouldShowMsSsoButton =
              isMSMultiTenant &&
              eligibleProfileTypes.some((profileType) =>
                profileTypes?.includes(profileType)
              )
            setIsMSMultiTenantClient(shouldShowMsSsoButton)
          } else {
            setIsMSMultiTenantClient(false)
          }
        },
      })
    }
    return () => {
      if (subscription && !subscription.closed) {
        subscription.unsubscribe()
      }
    }
  }, [loginTypeParam, featureFlags?.length])

  return isMSMultiTenantClient
}
